export enum MessageType {
    Error = 'error',
    Info = 'info',
}
